import BrowserSoftware from "./browserSoftware";
import CalllInteractions from "./callInterAction";
import { ChatState } from "../../../../base/models/model";
import LeftSidebarProfile from "./leftSidebarProfile";
import { Tabs } from "antd";
import styles from "./chatLeftSideBar.module.scss";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { GetItemFromStorage } from "../../../../custom_hooks/useStorage";
import { ChatActions } from "../../../../store/slices/chat_slice/chat_slice";
import { useDispatcher } from "../../../../custom_hooks/use_app_dispatch";
import { hassAccess } from "../../../../base/utils";

function ChatLeftSideBar() {
  const { TabPane } = Tabs;
  const chatReducer: ChatState = useSelector((state: any) => state.chatReducer);
  const [interactionType, setVal] = useState<any>(GetItemFromStorage("Interaction"));

  const dispatch = useDispatcher();
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 1199) {
        setIsSmallScreen(true);
      } else {
        setIsSmallScreen(false);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []); 

   const handleClick = () => {
    if (isSmallScreen) {
      dispatch(ChatActions.setViewProfile(false));
    }
  };
  return (
    <>
      {/* {chatReducer.currentSession.customerData !== "" ? <> */}
      {/* <div className={styles.leftSidebarTop}>
        <img src={userImg} alt="" className={styles.userImage} />
        <div className={styles.userName} >{chatReducer.currentSession.customerData === "" ? chatReducer.currentSession.customerDetails  : chatReducer?.currentSession?.customerData?.FirstName}</div>

      </div> */}
      {/* <div className={styles.leftSideBarTab}>
        <Tabs defaultActiveKey="profile" className="leftSidebarTab">
          <TabPane tab="Profile" key="profile">
            <LeftSidebarProfile apiData={chatReducer.currentSession} />
          </TabPane>
          {chatReducer?.currentSession?.channelType !== "Call" && <TabPane tab="Browser & Software" key="bs">
            <BrowserSoftware browserDetails={chatReducer.currentSession} />
          </TabPane>}
        </Tabs>
      </div> */}

      <div className={styles.leftSideBarTab}>
        
        <Tabs defaultActiveKey="User Info" className="leftSidebarTab chatscreenlefsidebar scroller agentchattabfix agentchattabfixtent">
          <TabPane tab= {<span><svg xmlns="http://www.w3.org/2000/svg" width="18" height="14" viewBox="0 0 18 14" fill="none" className={styles.leftsiderespoicon} onClick={handleClick}>
          <path d="M17.0175 6.24993H2.68844L6.73824 2.20013C7.03124 1.90713 7.03124 1.43253 6.73824 1.13963C6.44524 0.846734 5.97064 0.846634 5.67774 1.13963L1.40774 5.40913C0.978035 5.83883 0.742735 6.40863 0.745135 7.01363C0.748035 7.61323 0.984835 8.17473 1.40774 8.58983L5.67774 12.8603C5.82424 13.0068 6.01614 13.08 6.20804 13.08C6.39994 13.08 6.59184 13.0068 6.73834 12.8603C7.03134 12.5673 7.03134 12.0927 6.73834 11.7998L2.68904 7.75003H17.0176C17.4317 7.75003 17.7676 7.41413 17.7676 7.00003C17.7676 6.58593 17.4316 6.24993 17.0175 6.24993Z" fill="black" />
        </svg> User Info</span>}  key="userinfo">
            <LeftSidebarProfile />
          </TabPane>
          <TabPane tab={<span className={ hassAccess('workspace/interaction') ? "" :styles.chatgre}>Interactions</span>} key="Interactions">{ }
            {<BrowserSoftware />}
            {/* {(interactionType=='Email')?<BrowserSoftware />:<CalllInteractions />} */}
          </TabPane>
        </Tabs>
      </div>
    </>
  );
}
export default ChatLeftSideBar;
